import {
  ComponentFactory, ComponentFactoryResolver, ComponentRef,
  Directive, Input, OnChanges, SimpleChanges, TemplateRef, ViewContainerRef} from '@angular/core';
import {LoadingComponent} from '../loading/loading.component';
import {ServiceAnswer} from '../../shared/service-answer';
import {LoadingErrorComponent} from '../loading/loading-error/loading-error.component';
import {LoadingEmptyComponent} from '../loading/loading-empty/loading-empty.component';

export type LoadingControl = null | boolean | ServiceAnswer<any>;
export interface LoadingConfig {
  timeout?: number;
  messages?: {
    timeout?: string;
    empty?: string;
    error?: string;
  };
}
@Directive({
  selector: '[qmLoading]'
})
export class LoadingDirective implements OnChanges {
  private loadingComponentRef: ComponentRef<LoadingComponent>;
  private errorComponentRef: ComponentRef<LoadingErrorComponent>;
  private emptyComponentRef: ComponentRef<LoadingEmptyComponent>;
  private config: LoadingConfig;
  private loading: LoadingControl;

  constructor(private templateRef: TemplateRef<any>,
              private viewContainer: ViewContainerRef,
              private resolver: ComponentFactoryResolver) {
  }

  /**
   * Actual directive, AuthService is used to determine whether UI element is displayed or not.
   * @param {boolean} loading
   */
  @Input()
  set qmLoading(loading: LoadingControl) {
    this.loading = loading;
  }
  @Input()
  set qmLoadingConfig(config: LoadingConfig ) {
    this.config = config;
  }
  ngOnChanges(changes: SimpleChanges) {
    this.updateLoading(this.loading);
  }
  private updateLoading(loading: LoadingControl) {
    let show: LoadingStatus = LoadingStatus.LOADING;
    switch (loading) {
      case false:
        show = LoadingStatus.OK;
        break;
      case true:
        show = LoadingStatus.LOADING;
        break;
      default:
        show = this.getStatusFromServiceAnswer(loading);
        break;
    }
    // Change to switch-case
    if (show === LoadingStatus.LOADING) {
      this.viewContainer.clear();
      const factory: ComponentFactory<LoadingComponent> = this.resolver.resolveComponentFactory(LoadingComponent);
      this.loadingComponentRef = this.viewContainer.createComponent(factory);
      if (this.config?.timeout) {
        this.loadingComponentRef.instance.timeout = this.config?.timeout;
      }
      if (this.config?.messages?.timeout) {
        this.loadingComponentRef.instance.timeoutMessage = this.config.messages.timeout;
      }
    } else if (show === LoadingStatus.ERROR) {
      this.viewContainer.clear();
      const factory: ComponentFactory<LoadingErrorComponent> = this.resolver.resolveComponentFactory(LoadingErrorComponent);
      this.errorComponentRef = this.viewContainer.createComponent(factory);
      this.errorComponentRef.instance.answer = loading as any;
      if (this.config?.messages?.error) {
        this.errorComponentRef.instance.errorMsg = this.config.messages.error;
      }
    } else if (show === LoadingStatus.EMPTY) {
      this.viewContainer.clear();
      const factory: ComponentFactory<LoadingEmptyComponent> = this.resolver.resolveComponentFactory(LoadingEmptyComponent);
      this.emptyComponentRef = this.viewContainer.createComponent(factory);
      if (this.config?.messages?.empty) {
        this.emptyComponentRef.instance.emptyMsg = this.config.messages.empty;
      }
    } else {
      this.viewContainer.clear();
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
  private getStatusFromServiceAnswer(answer: ServiceAnswer<any>): LoadingStatus {
    let ret = LoadingStatus.LOADING;
    if (answer) {
      if (answer.isOk) {
        if (this.validateAnswerData(answer.data)) {
          ret = LoadingStatus.OK;
        } else {
          ret = LoadingStatus.EMPTY;
        }
      } else {
        ret = LoadingStatus.ERROR;
      }
    }
    return ret;
  }

  private validateAnswerData(data: any): boolean {
    if (Array.isArray(data)) {
      return data.length > 0;
    } else {
      return data;
    }
  }

}

enum LoadingStatus {
  LOADING,
  ERROR,
  EMPTY,
  OK
}
